import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import makeRequest from '../../../utils/makeRequest';
import { OK } from '../../../configs/serverStatusCodes';
import { updatePasswordFailed, updatePasswordSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import processError from '../../../utils/processError';

export default function* updatePassword(action) {
  try {
    const url = `${BACKEND_URL}/auth/update-password`;
    const userDataResponse = yield makeRequest(url, action.payload, action, 'POST');
    const responseJson = yield userDataResponse.json();
    if (userDataResponse && userDataResponse.status === OK) {
      yield put(updatePasswordSuccessful(responseJson));
      yield call(resolveActionPromise(action, responseJson));
    } else {
      yield put(updatePasswordFailed(responseJson));
      yield call(rejectActionPromise(action, responseJson));
    }
  } catch (e) {
    yield put(updatePasswordFailed(e));
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
